var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtLink',{staticClass:"transition text-base py-2 lg:py-4 relative font-medium",class:_vm.isActive && 'active-nav-item ',attrs:{"to":_vm.localizedHref + _vm.hash}},[_vm._t("default"),_vm._v("\n    "+_vm._s(_vm.label)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }